(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("ts-md5"));
	else if(typeof define === 'function' && define.amd)
		define(["ts-md5"], factory);
	else if(typeof exports === 'object')
		exports["manybuildlogic"] = factory(require("ts-md5"));
	else
		root["ManyBuildLogic"] = factory(root[undefined]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__15__) {
return 